import { client } from "api";
import { User } from "features/auth/types/user";
import { Company } from "models/Company";

export type GetUsersRequest = { companyId: Company["id"] };

export type GetUsersResponse = User[];

export const getUsers = ({ companyId }: GetUsersRequest) =>
  client.get<GetUsersResponse>(`/company/${companyId}/users`).then((res) => res.data);
